require("./transactionHistoryController");

"use strict";

angular.module('app.myProfile.transactionHistory.transactionHistoryDirective', [
    'app.myProfile.transactionHistory.transactionHistoryController'
])
.directive('transactionHistory', [
    function () {
        return {
            restrict: 'EA',
            templateUrl: 'components/myProfile/transactionHistory/transactionHistoryView.html',
            controller: 'transactionHistoryController',
            scope: true
        };
    }
]);


// WEBPACK FOOTER //
// ./app.v2/components/myProfile/transactionHistory/transactionHistoryDirective.js